import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/smsVerify', component: () => import('@/views/login/smsVerify'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  // 个人信息页面（隐藏在侧边栏）
  {
    path: '/profile',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'adminProfile',
        component: () => import('@/views/ums/profile/index'),
        meta: {title: '个人信息'}
      }
    ]
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {title: '首页', icon: 'dashboard'}
      }
    ]
  }
]

export const asyncRouterMap = [
  {
    path:'/blindBox',
    component: Layout,
    redirect: '/blindBox/boxInfo',
    name: 'blindBox',
    meta: {title: '盲盒商城', icon: 'example'},
    children: [
      // {
      //   path: 'blindBoxIp',
      //   name: 'blindBoxIp',
      //   component: () => import('@/views/blindBox/blindBoxIp/index'),
      //   meta: {title: '盲盒IP', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addBlindBoxIp',
      //   name: 'addBlindBoxIp',
      //   component: () => import('@/views/blindBox/blindBoxIp/add'),
      //   meta: {title: '添加盲盒IP'},
      //   hidden: true
      // },
      // {
      //   path: 'updateBlindBoxIp',
      //   name: 'updateBlindBoxIp',
      //   component: () => import('@/views/blindBox/blindBoxIp/update'),
      //   meta: {title: '修改盲盒IP'},
      //   hidden: true
      // },
      // {
      //   path: 'blindBoxTip',
      //   name: 'blindBoxTip',
      //   component: () => import('@/views/blindBox/blindBoxTip/index'),
      //   meta: {title: '盲盒标签', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addBlindBoxTip',
      //   name: 'addBlindBoxTip',
      //   component: () => import('@/views/blindBox/blindBoxTip/add'),
      //   meta: {title: '添加盲盒标签'},
      //   hidden: true
      // },
      // {
      //   path: 'updateBlindBoxTip',
      //   name: 'updateBlindBoxTip',
      //   component: () => import('@/views/blindBox/blindBoxTip/update'),
      //   meta: {title: '修改盲盒标签'},
      //   hidden: true
      // },
      // {
      //   path: 'blindBoxLevel',
      //   name: 'blindBoxLevel',
      //   component: () => import('@/views/blindBox/blindBoxLevel/index'),
      //   meta: {title: '盲盒等级', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addBlindBoxLevel',
      //   name: 'addBlindBoxLevel',
      //   component: () => import('@/views/blindBox/blindBoxLevel/add'),
      //   meta: {title: '添加盲盒等级'},
      //   hidden: true
      // },
      // {
      //   path: 'updateBlindBoxLevel',
      //   name: 'updateBlindBoxLevel',
      //   component: () => import('@/views/blindBox/blindBoxLevel/update'),
      //   meta: {title: '修改盲盒等级'},
      //   hidden: true
      // },
      {
        path: 'blindBoxGood',
        name: 'blindBoxGood',
        component: () => import('@/views/blindBox/blindBoxGood/index'),
        meta: {title: '盲盒商品', icon: 'ums-menu'}
      },
      {
        path: 'addBlindBoxGood',
        name: 'addBlindBoxGood',
        component: () => import('@/views/blindBox/blindBoxGood/add'),
        meta: {title: '添加盲盒商品'},
        hidden: true
      },
      {
        path: 'updateBlindBoxGood',
        name: 'updateBlindBoxGood',
        component: () => import('@/views/blindBox/blindBoxGood/update'),
        meta: {title: '修改盲盒商品'},
        hidden: true
      },
      {
        path: 'blindBoxInfo',
        name: 'blindBoxInfo',
        component: () => import('@/views/blindBox/blindBoxInfo/index'),
        meta: {title: '盲盒福袋', icon: 'ums-menu'}
      },
      {
        path: 'addBlindBoxInfo',
        name: 'addBlindBoxInfo',
        component: () => import('@/views/blindBox/blindBoxInfo/add'),
        meta: {title: '添加盲盒商品'},
        hidden: true
      },
      {
        path: 'updateBlindBoxInfo',
        name: 'updateBlindBoxInfo',
        component: () => import('@/views/blindBox/blindBoxInfo/update'),
        meta: {title: '修改盲盒商品'},
        hidden: true
      },
      {
        path: 'blindBoxWarehouse',
        name: 'blindBoxWarehouse',
        component: () => import('@/views/blindBox/blindBoxWarehouse/index'),
        meta: {title: '奖品管理', icon: 'ums-menu'}
      },
      {
        path: 'gameExchangeIntention',
        name: 'gameExchangeIntention',
        component: () => import('@/views/blindBox/gameExchange/intentions/index'),
        meta: {title: '游戏交换意向', icon: 'ums-menu'}
      },
      {
        path: 'gameExchangeMatch',
        name: 'gameExchangeMatch',
        component: () => import('@/views/blindBox/gameExchange/matches/index'),
        meta: {title: '游戏交换匹配', icon: 'ums-menu'}
      },
      {
        path: 'gameExchangeTransaction',
        name: 'gameExchangeTransaction',
        component: () => import('@/views/blindBox/gameExchange/transactions/index'),
        meta: {title: '游戏交换成交', icon: 'ums-menu'}
      },
      {
        path: 'gameExchangeAvailable',
        name: 'gameExchangeAvailable',
        component: () => import('@/views/blindBox/gameExchange/available/index'),
        meta: {title: '可交换游戏', icon: 'ums-menu'}
      },

    ]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商城商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'homeButton',
        name: 'homeButton',
        component: () => import('@/views/maintain/homeButton/index'),
        meta: {title: '商城金刚区', icon: 'ums-menu'}
      },
      {
        path: 'addHomeButton',
        name: 'addHomeButton',
        component: () => import('@/views/maintain/homeButton/add'),
        meta: {title: '添加商城金刚区'},
        hidden: true
      },
      {
        path: 'updateHomeButton',
        name: 'updateHomeButton',
        component: () => import('@/views/maintain/homeButton/update'),
        meta: {title: '修改商城金刚区'},
        hidden: true
      },
    ]
  },
  {
    path: '/dist',
    component: Layout,
    redirect: '/dist/platform',
    name: 'dist',
    meta: {title: '分销系统', icon: 'nested'},
    children: [
      // {
      //   path: 'platform',
      //   name: 'platform',
      //   component: () => import('@/views/dist/platform/index'),
      //   meta: {title: '平台管理', icon: 'component'}
      // },
      // {
      //   path: 'addPlatform',
      //   name: 'addPlatform',
      //   component: () => import('@/views/dist/platform/add'),
      //   meta: {title: '添加平台'},
      //   hidden: true
      // },
      // {
      //   path: 'updatePlatform',
      //   name: 'updatePlatform',
      //   component: () => import('@/views/dist/platform/update'),
      //   meta: {title: '修改平台'},
      //   hidden: true
      // },
      {
        path: 'fhyxProduct',
        name: 'fhyxProduct',
        component: () => import('@/views/dist/fhyxProduct/index'),
        meta: {title: '凤凰商品管理', icon: 'shopping'}
      },
      {
        path: 'haiweiProduct',
        name: 'haiweiProduct',
        component: () => import('@/views/dist/haiweiProduct/index'),
        meta: {title: '海威商品管理', icon: 'shopping'}
      },
      // {
      //   path: 'order',
      //   name: 'distOrder',
      //   component: () => import('@/views/dist/order/index'),
      //   meta: {title: '分销订单', icon: 'order'}
      // }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '商城订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/returnReason/index'),
        meta: {title: '退货理由', icon: 'ums-menu'}
      },
      {
        path: 'addOrderReturnReason',
        name: 'addOrderReturnReason',
        component: () => import('@/views/oms/returnReason/add'),
        meta: {title: '添加退货理由'},
        hidden: true
      },
      {
        path: 'updateOrderReturnReason',
        name: 'updateOrderReturnReason',
        component: () => import('@/views/oms/returnReason/update'),
        meta: {title: '修改退货理由'},
        hidden: true
      },
      {
        path: 'returnInfo',
        name: 'returnInfo',
        component: () => import('@/views/oms/returnInfo/index'),
        meta: {title: '退货申请', icon: 'ums-menu'}
      },
      {
        path: 'addReturnInfo',
        name: 'addReturnInfo',
        component: () => import('@/views/oms/returnInfo/add'),
        meta: {title: '添加退货申请'},
        hidden: true
      },
      {
        path: 'updateReturnInfo',
        name: 'updateReturnInfo',
        component: () => import('@/views/oms/returnInfo/update'),
        meta: {title: '修改退货申请'},
        hidden: true
      },
      {
        path: 'returnAddress',
        name: 'returnAddress',
        component: () => import('@/views/oms/returnAddress/index'),
        meta: {title: '退货地址管理', icon: 'ums-menu'}
      },
      {
        path: 'addReturnAddress',
        name: 'addReturnAddress',
        component: () => import('@/views/oms/returnAddress/add'),
        meta: {title: '添加退货地址'},
        hidden: true
      },
      {
        path: 'updateReturnAddress',
        name: 'updateReturnAddress',
        component: () => import('@/views/oms/returnAddress/update'),
        meta: {title: '修改退货地址'},
        hidden: true
      },
    ]
  },
  {
    path:'/maintain',
    component: Layout,
    redirect: '/maintain/coupon',
    name: 'maintain',
    meta: {title: '运营管理', icon: 'sms'},
    children: [
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/act/coupon/index'),
        meta: {title: '优惠券管理', icon: 'ums-menu'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/act/coupon/add'),
        meta: {title: '添加优惠券管理'},
        hidden: true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/act/coupon/update'),
        meta: {title: '修改优惠券管理'},
        hidden: true
      },
      {
        path: 'propCard',
        name: 'propCard',
        component: () => import('@/views/act/propCard/index'),
        meta: {title: '道具卡管理', icon: 'ums-menu'}
      },
      {
        path: 'addPropCard',
        name: 'addPropCard',
        component: () => import('@/views/act/propCard/add'),
        meta: {title: '添加道具卡管理'},
        hidden: true
      },
      {
        path: 'updatePropCard',
        name: 'updatePropCard',
        component: () => import('@/views/act/propCard/update'),
        meta: {title: '修改道具卡管理'},
        hidden: true
      },
      {
        path: 'propCardHistory',
        name: 'propCardHistory',
        component: () => import('@/views/act/propCardHistory/index'),
        meta: {title: '道具卡发放历史', icon: 'ums-menu'},
        hidden: true
      },
      {
        path: 'addPropCardHistory',
        name: 'addPropCardHistory',
        component: () => import('@/views/act/propCardHistory/add'),
        meta: {title: '添加道具卡发放历史'},
        hidden: true
      },
      {
        path: 'updatePropCardHistory',
        name: 'updatePropCardHistory',
        component: () => import('@/views/act/propCardHistory/update'),
        meta: {title: '修改道具卡发放历史'},
        hidden: true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/act/couponHistory/index'),
        meta: {title: '优惠券发放历史', icon: 'ums-menu'},
        hidden: true
      },
      {
        path: 'addCouponHistory',
        name: 'addCouponHistory',
        component: () => import('@/views/act/couponHistory/add'),
        meta: {title: '添加优惠券发放历史'},
        hidden: true
      },
      {
        path: 'updateCouponHistory',
        name: 'updateCouponHistory',
        component: () => import('@/views/act/couponHistory/update'),
        meta: {title: '修改优惠券发放历史'},
        hidden: true
      },
      {
        path: 'exchangeRecord',
        name: 'exchangeRecord',
        component: () => import('@/views/act/exchangeRecord/index'),
        meta: {title: '兑换码管理', icon: 'ums-menu'},
      },
      {
        path: 'welfareInviteCode',
        name: 'welfareInviteCode',
        component: () => import('@/views/welfare/inviteCode/index'),
        meta: {title: '福利邀请码', icon: 'ums-menu'}
      },
      {
        path: 'welfareInviteCodeAdd',
        name: 'welfareInviteCodeAdd',
        component: () => import('@/views/welfare/inviteCode/form'),
        meta: {title: '添加邀请码'},
        hidden: true
      },
      {
        path: 'welfareInviteCodeEdit',
        name: 'welfareInviteCodeEdit',
        component: () => import('@/views/welfare/inviteCode/form'),
        meta: {title: '编辑邀请码'},
        hidden: true
      },
      {
        path: 'welfareInviteCodeDetail',
        name: 'welfareInviteCodeDetail',
        component: () => import('@/views/welfare/inviteCode/detail'),
        meta: {title: '邀请码详情'},
        hidden: true
      },


      {
        path: 'exchangeItem',
        name: 'advExchangeItem',
        component: () => import('@/views/advance/exchangeItem/index'),
        meta: {title: '进阶管理', icon: 'ums-menu'}
      },
      {
        path: 'exchangeItem/add',
        name: 'addAdvExchangeItem',
        component: () => import('@/views/advance/exchangeItem/add'),
        meta: {title: '添加进阶项'},
        hidden: true
      },
      {
        path: 'exchangeItem/update/:id',
        name: 'updateAdvExchangeItem',
        component: () => import('@/views/advance/exchangeItem/update'),
        meta: {title: '修改进阶项'},
        hidden: true
      },
      {
        path: 'exchangeOrder',
        name: 'advExchangeOrder',
        component: () => import('@/views/advance/exchangeOrder/index'),
        meta: {title: '进阶订单', icon: 'ums-menu'}
      },

      {
        path: 'campaign',
        name: 'actCampaign',
        component: () => import('@/views/act/campaign/index'),
        meta: {title: '活动管理', icon: 'ums-menu'}
      },
      {
        path: 'addCampaign',
        name: 'addActCampaign',
        component: () => import('@/views/act/campaign/add'),
        meta: {title: '添加活动管理'},
        hidden: true
      },
      {
        path: 'updateCampaign',
        name: 'updateActCampaign',
        component: () => import('@/views/act/campaign/update'),
        meta: {title: '修改活动管理'},
        hidden: true
      },
      {
        path: 'campaignTier',
        name: 'actCampaignTier',
        component: () => import('@/views/act/campaignTier/index'),
        meta: {title: '活动档位管理', icon: 'ums-menu'}
      },
      {
        path: 'addCampaignTier',
        name: 'addActCampaignTier',
        component: () => import('@/views/act/campaignTier/add'),
        meta: {title: '添加活动档位'},
        hidden: true
      },
      {
        path: 'updateCampaignTier',
        name: 'updateActCampaignTier',
        component: () => import('@/views/act/campaignTier/update'),
        meta: {title: '修改活动档位'},
        hidden: true
      },
      {
        path: 'campaignParticipation',
        name: 'actCampaignParticipation',
        component: () => import('@/views/act/campaignParticipation/index'),
        meta: {title: '活动参与记录', icon: 'ums-menu'}
      },
      {
        path: 'addCampaignParticipation',
        name: 'addActCampaignParticipation',
        component: () => import('@/views/act/campaignParticipation/add'),
        meta: {title: '添加参与记录'},
        hidden: true
      },
      {
        path: 'updateCampaignParticipation',
        name: 'updateActCampaignParticipation',
        component: () => import('@/views/act/campaignParticipation/update'),
        meta: {title: '修改参与记录'},
        hidden: true
      },
      {
        path: 'campaignHelp',
        name: 'actCampaignHelp',
        component: () => import('@/views/act/campaignHelp/index'),
        meta: {title: '活动助力记录', icon: 'ums-menu'}
      },
      {
        path: 'addCampaignHelp',
        name: 'addActCampaignHelp',
        component: () => import('@/views/act/campaignHelp/add'),
        meta: {title: '添加助力记录'},
        hidden: true
      },
      {
        path: 'updateCampaignHelp',
        name: 'updateActCampaignHelp',
        component: () => import('@/views/act/campaignHelp/update'),
        meta: {title: '修改助力记录'},
        hidden: true
      },
      {
        path: 'campaignAwardHistory',
        name: 'actCampaignAwardHistory',
        component: () => import('@/views/act/campaignAwardHistory/index'),
        meta: {title: '活动奖励记录', icon: 'ums-menu'}
      },
      {
        path: 'addCampaignAwardHistory',
        name: 'addActCampaignAwardHistory',
        component: () => import('@/views/act/campaignAwardHistory/add'),
        meta: {title: '添加奖励记录'},
        hidden: true
      },
      {
        path: 'updateCampaignAwardHistory',
        name: 'updateActCampaignAwardHistory',
        component: () => import('@/views/act/campaignAwardHistory/update'),
        meta: {title: '修改奖励记录'},
        hidden: true
      },
      // 极光推送管理与监控
      {
        path: 'pushInfo',
        name: 'pushInfo',
        component: () => import('@/views/ums/pushInfo/index'),
        meta: {title: '消息推送', icon: 'ums-resource'}
      },
      {
        path: 'addPushInfo',
        name: 'addPushInfo',
        component: () => import('@/views/ums/pushInfo/add'),
        meta: {title: '新增消息推送'},
        hidden: true
      },
      {
        path: 'updatePushInfo',
        name: 'updatePushInfo',
        component: () => import('@/views/ums/pushInfo/update'),
        meta: {title: '编辑极消息推送'},
        hidden: true
      },
      {
        path: 'pushDetail',
        name: 'pushDetail',
        component: () => import('@/views/ums/pushDetail/index'),
        meta: {title: '消息推送明细'},
        hidden: true
      },
    ]
  },
  {
    path:'/member',
    component: Layout,
    redirect: '/member/member',
    name: 'member',
    meta: {title: '会员管理', icon: 'ums'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/member/member/index'),
        meta: {title: '会员管理', icon: 'ums-resource'}
      },
      {
        path: 'addMember',
        name: 'addMember',
        component: () => import('@/views/member/member/add'),
        meta: {title: '添加会员'},
        hidden: true
      },
      {
        path: 'updateMember',
        name: 'updateMember',
        component: () => import('@/views/member/member/update'),
        meta: {title: '修改会员'},
        hidden: true
      },
      {
        path: 'invitationMember',
        name: 'invitationMember',
        component: () => import('@/views/member/member/invitationMember'),
        meta: {title: '邀请用户明细'},
        hidden: true
      },
      {
        path: 'robot',
        name: 'robot',
        component: () => import('@/views/member/robot/index'),
        meta: {title: '机器人管理', icon: 'ums-resource'}
      },
      {
        path: 'addRobot',
        name: 'addRobot',
        component: () => import('@/views/member/robot/add'),
        meta: {title: '添加机器人'},
        hidden: true
      },
      {
        path: 'updateRobot',
        name: 'updateRobot',
        component: () => import('@/views/member/robot/update'),
        meta: {title: '修改机器人'},
        hidden: true
      },
      {
        path: 'blackIp',
        name: 'blackIp',
        component: () => import('@/views/member/blackIp/index'),
        meta: {title: '黑名单管理', icon: 'ums-resource'}
      },
      {
        path: 'addBlackIp',
        name: 'addBlackIp',
        component: () => import('@/views/member/blackIp/add'),
        meta: {title: '添加黑名单'},
        hidden: true
      },
      {
        path: 'updateBlackIp',
        name: 'updateBlackIp',
        component: () => import('@/views/member/blackIp/update'),
        meta: {title: '修改黑名单'},
        hidden: true
      },
      {
        path: 'memberLevel',
        name: 'memberLevel',
        component: () => import('@/views/member/memberLevel/index'),
        meta: {title: '会员等级', icon: 'ums-resource'}
      },
      {
        path: 'addMemberLevel',
        name: 'addMemberLevel',
        component: () => import('@/views/member/memberLevel/add'),
        meta: {title: '添加会员等级'},
        hidden: true
      },
      {
        path: 'updateMemberLevel',
        name: 'updateMemberLevel',
        component: () => import('@/views/member/memberLevel/update'),
        meta: {title: '修改会员等级'},
        hidden: true
      },
      {
        path: 'testAccount',
        name: 'testAccount',
        component: () => import('@/views/member/testAccount/index'),
        meta: {title: '测试账号管理', icon: 'ums-resource'}
      },
      // {
      //   path: 'memberRateConfig',
      //   name: 'memberRateConfig',
      //   component: () => import('@/views/member/memberRateConfig/index'),
      //   meta: {title: '会员概率设置', icon: 'ums-resource'}
      // },
      // {
      //   path: 'addMemberRateConfig',
      //   name: 'addMemberRateConfig',
      //   component: () => import('@/views/member/memberRateConfig/add'),
      //   meta: {title: '添加会员概率设置'},
      //   hidden: true
      // },
      // {
      //   path: 'updateMemberRateConfig',
      //   name: 'updateMemberRateConfig',
      //   component: () => import('@/views/member/memberRateConfig/update'),
      //   meta: {title: '修改会员概率设置'},
      //   hidden: true
      // },
      // {
      //   path: 'rebateRecord',
      //   name: 'rebateRecord',
      //   component: () => import('@/views/member/rebateRecord/index'),
      //   meta: {title: '返佣记录', icon: 'ums-resource'}
      // },
    ]
  },
  {
    path: '/game',
    component: Layout,
    redirect: '/game/steamGame',
    name: 'game',
    meta: {title: '游戏管理', icon: 'example'},
    children: [
      {
        path: 'steamGame',
        name: 'steamGame',
        component: () => import('@/views/steam/index'),
        meta: {title: 'Steam游戏管理', icon: 'product-list'}
      },
      {
        path: 'gameFocus',
        name: 'gameFocus',
        component: () => import('@/views/steam/gameFocus/index'),
        meta: {title: '游戏关注度', icon: 'star'}
      },
      {
        path: 'steamCdk',
        name: 'steamCdk',
        component: () => import('@/views/steam/cdk/index'),
        meta: {title: 'CDK列表', icon: 'product-list'}
      },
      {
        path: 'steamCdkOperationLogs',
        name: 'steamCdkOperationLogs',
        component: () => import('@/views/steam/cdk/operationLogs'),
        meta: {title: 'CDK操作日志', icon: 'ums-menu'}
      },
      {
        path: 'steamCdkRecord',
        name: 'steamCdkRecord',
        component: () => import('@/views/steam/cdk/useRecord'),
        meta: {title: 'CDK明细', icon: 'order'}
      },
      {
        path: 'steamCdkDetail',
        name: 'SteamCdkDetail',
        component: () => import('@/views/steam/cdk/detail'),
        meta: {title: 'CDK明细管理'},
        hidden: true
      },
      {
        path: 'application',
        name: 'offlineDeliveryApplication',
        component: () => import('@/views/offlineDelivery/application/index'),
        meta: {title: '提货申请', icon: 'product-list'}
      },
      {
        path: 'application/detail',
        name: 'offlineDeliveryDetail',
        component: () => import('@/views/offlineDelivery/application/detail'),
        meta: {title: '申请详情'},
        hidden: true
      },
      {
        path: 'account',
        name: 'deliveryAccount',
        component: () => import('@/views/offlineDelivery/account/index'),
        meta: {title: '发货账号', icon: 'ums-admin'}
      },
      {
        path: 'gameInfo',
        name: 'miniGameInfo',
        component: () => import('@/views/miniGame/gameInfo/index'),
        meta: {title: '游戏信息管理', icon: 'product-list'}
      },
      {
        path: 'addGameInfo',
        name: 'addMiniGameInfo',
        component: () => import('@/views/miniGame/gameInfo/add'),
        meta: {title: '添加游戏信息'},
        hidden: true
      },
      {
        path: 'updateGameInfo',
        name: 'updateMiniGameInfo',
        component: () => import('@/views/miniGame/gameInfo/update'),
        meta: {title: '修改游戏信息'},
        hidden: true
      },
      {
        path: 'playRecord',
        name: 'miniGamePlayRecord',
        component: () => import('@/views/miniGame/playRecord/index'),
        meta: {title: '游戏记录管理', icon: 'ums-menu'}
      },
      {
        path: 'rewardRecord',
        name: 'miniGameRewardRecord',
        component: () => import('@/views/miniGame/rewardRecord/index'),
        meta: {title: '奖励记录管理', icon: 'ums-menu'}
      }
    ]
  },
  {
    path: '/forum',
    component: Layout,
    redirect: '/forum/forumPost',
    name: 'forum',
    meta: {title: '论坛管理', icon: 'example'},
    children: [
      {
        path: 'forumPost',
        name: 'forumPost',
        component: () => import('@/views/forum/forumPost/index'),
        meta: {title: '帖子管理', icon: 'document'}
      },
      {
        path: 'forumTopic',
        name: 'forumTopic',
        component: () => import('@/views/forum/forumTopic/index'),
        meta: {title: '话题管理', icon: 'component'}
      },
      {
        path: 'addForumPost',
        name: 'addForumPost',
        component: () => import('@/views/forum/forumPost/add'),
        meta: {title: '添加帖子'},
        hidden: true
      },
      {
        path: 'updateForumPost/:id',
        name: 'updateForumPost',
        component: () => import('@/views/forum/forumPost/update'),
        meta: {title: '编辑帖子'},
        hidden: true
      },
      {
        path: 'viewForumPost',
        name: 'viewForumPost',
        component: () => import('@/views/forum/forumPost/view'),
        meta: {title: '帖子查看'},
        hidden: true
      },
      {
        path: 'forumUserStats',
        name: 'forumUserStats',
        component: () => import('@/views/forum/forumUserStats/index'),
        meta: {title: '用户统计', icon: 'ums-resource'}
      },
      {
        path: 'forumReport',
        name: 'forumReport',
        component: () => import('@/views/forum/forumReport/index'),
        meta: {title: '举报管理', icon: 'warning'}
      },
      {
        path: 'forumReportReason',
        name: 'forumReportReason',
        component: () => import('@/views/forum/forumReportReason/index'),
        meta: {title: '举报原因', icon: 'list'}
      },
      {
        path: 'forumUserStatsDetail',
        name: 'forumUserStatsDetail',
        component: () => import('@/views/forum/forumUserStats/detail'),
        meta: {title: '用户统计详情'},
        hidden: true
      },
      {
        path: 'announcement',
        name: 'forumAnnouncement',
        component: () => import('@/views/forum/announcement/index'),
        meta: {title: '社区公告', icon: 'ums-menu'}
      },
      {
        path: 'addAnnouncement',
        name: 'addForumAnnouncement',
        component: () => import('@/views/forum/announcement/add'),
        meta: {title: '添加公告'},
        hidden: true
      },
      {
        path: 'updateAnnouncement',
        name: 'updateForumAnnouncement',
        component: () => import('@/views/forum/announcement/update'),
        meta: {title: '修改公告'},
        hidden: true
      }
    ]
  },

  {
    path:'/report',
    component: Layout,
    redirect: '/report/memberBalanceReport',
    name: 'report',
    meta: {title: '报表管理', icon: 'example'},
    children: [
      {
        path: 'reportData',
        name: 'reportData',
        component: () => import('@/views/report/reportData/index'),
        meta: {title: '数据可视化', icon: 'ums-menu'}
      },
      {
        path: 'memberConsumption',
        name: 'memberConsumption',
        component: () => import('@/views/report/memberConsumption/index'),
        meta: {title: '用户消费统计', icon: 'ums-menu'}
      },
      {
        path: 'blindBoxDashboard',
        name: 'blindBoxDashboard',
        component: () => import('@/views/blindBox/dashboard/index'),
        meta: {title: '盲盒数据总览', icon: 'dashboard'}
      },
      {
        path: 'blindBoxRoomStatistics',
        name: 'blindBoxRoomStatistics',
        component: () => import('@/views/blindBox/roomStatistics/index'),
        meta: {title: '盲盒数据统计', icon: 'table'}
      },
      // {
      //   path: 'memberPrize',
      //   name: 'memberPrize',
      //   component: () => import('@/views/report/memberPrize/index'),
      //   meta: {title: '用户中奖统计', icon: 'ums-menu'}
      // },

    ]
  },
  {
    path:'/static',
    component: Layout,
    redirect: '/static/homeBackground',
    name: 'static',
    meta: {title: '静态资源', icon: 'example'},
    children: [

      {
        path: 'homeBackground',
        name: 'homeBackground',
        component: () => import('@/views/static/homeBackground/index'),
        meta: {title: 'banner管理', icon: 'ums-menu'}
      },
      {
        path: 'addHomeBackground',
        name: 'addHomeBackground',
        component: () => import('@/views/static/homeBackground/add'),
        meta: {title: '添加banner管理'},
        hidden: true
      },
      {
        path: 'updateHomeBackground',
        name: 'updateHomeBackground',
        component: () => import('@/views/static/homeBackground/update'),
        meta: {title: '修改banner管理'},
        hidden: true
      },
      {
        path: 'staticResource',
        name: 'staticResource',
        component: () => import('@/views/static/staticResource/index'),
        meta: {title: '静态资源列表', icon: 'ums-menu'}
      },
      {
        path: 'addStaticResource',
        name: 'addStaticResource',
        component: () => import('@/views/static/staticResource/add'),
        meta: {title: '添加静态资源列表'},
        hidden: true
      },
      {
        path: 'updateStaticResource',
        name: 'updateStaticResource',
        component: () => import('@/views/static/staticResource/update'),
        meta: {title: '修改静态资源列表'},
        hidden: true
      },
      {
        path: 'staticMsg',
        name: 'staticMsg',
        component: () => import('@/views/static/staticMsg/index'),
        meta: {title: '文本资源列表', icon: 'ums-menu'}
      },
      {
        path: 'addStaticMsg',
        name: 'addStaticMsg',
        component: () => import('@/views/static/staticMsg/add'),
        meta: {title: '添加文本资源列表'},
        hidden: true
      },
      {
        path: 'updateStaticMsg',
        name: 'updateStaticMsg',
        component: () => import('@/views/static/staticMsg/update'),
        meta: {title: '修改文本资源列表'},
        hidden: true
      },
      {
        path: 'shareInfo',
        name: 'shareInfo',
        component: () => import('@/views/static/shareInfo/index'),
        meta: {title: '分享链接列表', icon: 'ums-menu'}
      },
      {
        path: 'addShareInfo',
        name: 'addShareInfo',
        component: () => import('@/views/static/shareInfo/add'),
        meta: {title: '添加分享链接列表'},
        hidden: true
      },
      {
        path: 'updateShareInfo',
        name: 'updateShareInfo',
        component: () => import('@/views/static/shareInfo/update'),
        meta: {title: '修改分享链接列表'},
        hidden: true
      },
      {
        path: 'hotSearch',
        name: 'hotSearch',
        component: () => import('@/views/maintain/hotSearch/index'),
        meta: {title: '热搜管理', icon: 'ums-menu'}
      },
      {
        path: 'addHotSearch',
        name: 'addHotSearch',
        component: () => import('@/views/maintain/hotSearch/add'),
        meta: {title: '添加热搜管理'},
        hidden: true
      },
      {
        path: 'updateHotSearch',
        name: 'updateHotSearch',
        component: () => import('@/views/maintain/hotSearch/update'),
        meta: {title: '修改热搜管理'},
        hidden: true
      },
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '系统管理', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '管理员列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      // {
      //   path: 'resource',
      //   name: 'resource',
      //   component: () => import('@/views/ums/resource/index'),
      //   meta: {title: '资源列表', icon: 'ums-resource'}
      // },
      // {
      //   path: 'resourceCategory',
      //   name: 'resourceCategory',
      //   component: () => import('@/views/ums/resource/categoryList'),
      //   meta: {title: '资源分类'},
      //   hidden: true
      // },
      {
        path: 'memberMessage',
        name: 'memberMessage',
        component: () => import('@/views/member/memberMessage/index'),
        meta: {title: '消息管理', icon: 'ums-resource'}
      },
      {
        path: 'quartzTask',
        name: 'quartzTask',
        component: () => import('@/views/ums/quartzTask/index'),
        meta: {title: '定时任务管理', icon: 'ums-admin'}
      },
      {
        path: 'addQuartzTask',
        name: 'addQuartzTask',
        component: () => import('@/views/ums/quartzTask/add'),
        meta: {title: '新增定时任务'},
        hidden: true
      },
      {
        path: 'updateQuartzTask',
        name: 'updateQuartzTask',
        component: () => import('@/views/ums/quartzTask/update'),
        meta: {title: '编辑定时任务'},
        hidden: true
      },


      // {
      //   path: 'kf',
      //   name: 'kf',
      //   component: () => import('@/views/ums/kf/index'),
      //   meta: {title: '客服管理', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addKf',
      //   name: 'addKf',
      //   component: () => import('@/views/ums/kf/add'),
      //   meta: {title: '添加客服管理'},
      //   hidden: true
      // },
      // {
      //   path: 'updateKf',
      //   name: 'updateKf',
      //   component: () => import('@/views/ums/kf/update'),
      //   meta: {title: '修改客服管理'},
      //   hidden: true
      // },
      // {
      //   path: 'robotTask',
      //   name: 'robotTask',
      //   component: () => import('@/views/ums/robotTask/index'),
      //   meta: {title: '刷单任务', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addRobotTask',
      //   name: 'addRobotTask',
      //   component: () => import('@/views/ums/robotTask/add'),
      //   meta: {title: '添加刷单任务'},
      //   hidden: true
      // },
      // {
      //   path: 'updateRobotTask',
      //   name: 'updateRobotTask',
      //   component: () => import('@/views/ums/robotTask/update'),
      //   meta: {title: '修改刷单任务'},
      //   hidden: true
      // },
      {
        path: 'balanceSetting',
        name: 'balanceSetting',
        component: () => import('@/views/ums/balanceSetting/index'),
        meta: {title: '充值设置', icon: 'ums-menu'}
      },
      {
        path: 'addBalanceSetting',
        name: 'addBalanceSetting',
        component: () => import('@/views/ums/balanceSetting/add'),
        meta: {title: '添加充值设置'},
        hidden: true
      },
      {
        path: 'updateBalanceSetting',
        name: 'updateBalanceSetting',
        component: () => import('@/views/ums/balanceSetting/update'),
        meta: {title: '修改充值设置'},
        hidden: true
      },

      {
        path: 'paymentType',
        name: 'paymentType',
        component: () => import('@/views/ums/paymentType/index'),
        meta: {title: '支付类型', icon: 'ums-menu'}
      },
      {
        path: 'addPaymentType',
        name: 'addPaymentType',
        component: () => import('@/views/ums/paymentType/add'),
        meta: {title: '添加支付类型'},
        hidden: true
      },
      {
        path: 'updatePaymentType',
        name: 'updatePaymentType',
        component: () => import('@/views/ums/paymentType/update'),
        meta: {title: '修改支付类型'},
        hidden: true
      },
      {
        path: 'pushConfig',
        name: 'pushConfig',
        component: () => import('@/views/ums/pushConfig/index'),
        meta: {title: '推送配置', icon: 'ums-menu'}
      },
      {
        path: 'systemConfig',
        name: 'systemConfig',
        component: () => import('@/views/ums/systemConfig/index'),
        meta: {title: '配置信息', icon: 'ums-menu'}
      },
      {
        path: 'addSystemConfig',
        name: 'addSystemConfig',
        component: () => import('@/views/ums/systemConfig/add'),
        meta: {title: '添加配置信息'},
        hidden: true
      },
      {
        path: 'updateSystemConfig',
        name: 'updateSystemConfig',
        component: () => import('@/views/ums/systemConfig/update'),
        meta: {title: '修改配置信息'},
        hidden: true
      },
      {
        path: 'appVersion',
        name: 'appVersion',
        component: () => import('@/views/ums/appVersion/index'),
        meta: {title: 'APP版本管理', icon: 'ums-menu'}
      },
      {
        path: 'addAppVersion',
        name: 'addAppVersion',
        component: () => import('@/views/ums/appVersion/add'),
        meta: {title: '添加版本'},
        hidden: true
      },
      {
        path: 'updateAppVersion',
        name: 'updateAppVersion',
        component: () => import('@/views/ums/appVersion/update'),
        meta: {title: '修改版本'},
        hidden: true
      },

    ]
  },
  {
    path:'/apk',
    component: Layout,
    redirect: '/apk/apkInfo',
    name: 'apk',
    meta: {title: 'apk上传', icon: 'example'},
    children: [
      {
        path: 'apkInfo',
        name: 'apkInfo',
        component: () => import('@/views/apk/apkInfo/index'),
        meta: {title: 'apk上传列表', icon: 'ums-menu'}
      },
      {
        path: 'addApkInfo',
        name: 'addApkInfo',
        component: () => import('@/views/apk/apkInfo/add'),
        meta: {title: '添加apk上传'},
        hidden: true
      },
      {
        path: 'updateApkInfo',
        name: 'updateApkInfo',
        component: () => import('@/views/apk/apkInfo/update'),
        meta: {title: '修改apk上传'},
        hidden: true
      },

    ]
  },
  {
    path:'/log',
    component: Layout,
    redirect: '/log/promotionInfo',
    name: 'log',
    meta: {title: '日志', icon: 'ums'},
    children: [
      {
        path: 'balanceOperateLog',
        name: 'balanceOperateLog',
        component: () => import('@/views/log/balanceOperateLog/index'),
        meta: {title: '会员金币日志', icon: 'ums-resource'}
      },
      {
        path: 'addBalanceOperateLog',
        name: 'addBalanceOperateLog',
        component: () => import('@/views/log/balanceOperateLog/add'),
        meta: {title: '添加会员金币日志'},
        hidden: true
      },
      {
        path: 'updateBalanceOperateLogg',
        name: 'updateBalanceOperateLogg',
        component: () => import('@/views/log/balanceOperateLog/update'),
        meta: {title: '修改会员金币日志'},
        hidden: true
      },
      // {
      //   path: 'promotionInfo',
      //   name: 'promotionInfo',
      //   component: () => import('@/views/log/promotionInfo/index'),
      //   meta: {title: '会员推广费日志查询', icon: 'ums-resource'}
      // },
      // {
      //   path: 'addPromotionInfo',
      //   name: 'addPromotionInfo',
      //   component: () => import('@/views/log/promotionInfo/add'),
      //   meta: {title: '添加会员推广费日志'},
      //   hidden: true
      // },
      // {
      //   path: 'updatePromotionInfo',
      //   name: 'updatePromotionInfo',
      //   component: () => import('@/views/log/promotionInfo/update'),
      //   meta: {title: '修改会员推广费日志'},
      //   hidden: true
      // },
      {
        path: 'opLogMember',
        name: 'opLogMember',
        component: () => import('@/views/log/opLogMember/index'),
        meta: {title: '会员日志', icon: 'ums-resource'}
      },
      {
        path: 'addOpLogMember',
        name: 'addOpLogMember',
        component: () => import('@/views/log/opLogMember/add'),
        meta: {title: '添加会员日志'},
        hidden: true
      },
      {
        path: 'updateOpLogMember',
        name: 'updateOpLogMember',
        component: () => import('@/views/log/opLogMember/update'),
        meta: {title: '修改会员日志'},
        hidden: true
      },
      {
        path: 'opLogAdmin',
        name: 'opLogAdmin',
        component: () => import('@/views/log/opLogAdmin/index'),
        meta: {title: '管理员日志', icon: 'ums-resource'}
      },
    ]
  },


  {
    path:'/service',
    component: Layout,
    redirect: '/service/feedbackType',
    name: 'service',
    meta: {title: '客户服务', icon: 'example'},
    children: [
      {
        path: 'feedbackType',
        name: 'feedbackType',
        component: () => import('@/views/service/feedbackType/index'),
        meta: {title: '意见反馈类型', icon: 'ums-menu'}
      },
      {
        path: 'addFeedbackType',
        name: 'addFeedbackType',
        component: () => import('@/views/service/feedbackType/add'),
        meta: {title: '添加意见反馈类型'},
        hidden: true
      },
      {
        path: 'updateFeedbackType',
        name: 'updateFeedbackType',
        component: () => import('@/views/service/feedbackType/update'),
        meta: {title: '修改意见反馈类型'},
        hidden: true
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/views/service/feedback/index'),
        meta: {title: '意见反馈', icon: 'ums-menu'}
      },
      {
        path: 'addFeedback',
        name: 'addFeedback',
        component: () => import('@/views/service/feedback/add'),
        meta: {title: '添加意见反馈'},
        hidden: true
      },
      {
        path: 'updateFeedback',
        name: 'updateFeedback',
        component: () => import('@/views/service/feedback/update'),
        meta: {title: '修改意见反馈'},
        hidden: true
      },
      // {
      //   path: 'cooperationType',
      //   name: 'cooperationType',
      //   component: () => import('@/views/service/cooperationType/index'),
      //   meta: {title: '合作信息类目', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addCooperationType',
      //   name: 'addCooperationType',
      //   component: () => import('@/views/service/cooperationType/add'),
      //   meta: {title: '添加合作信息类目'},
      //   hidden: true
      // },
      // {
      //   path: 'updateCooperationType',
      //   name: 'updateCooperationType',
      //   component: () => import('@/views/service/cooperationType/update'),
      //   meta: {title: '修改合作信息类目'},
      //   hidden: true
      // },
      // {
      //   path: 'cooperation',
      //   name: 'cooperation',
      //   component: () => import('@/views/service/cooperation/index'),
      //   meta: {title: '合作信息', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addCooperation',
      //   name: 'addCooperation',
      //   component: () => import('@/views/service/cooperation/add'),
      //   meta: {title: '添加合作信息'},
      //   hidden: true
      // },
      // {
      //   path: 'updateCooperation',
      //   name: 'updateCooperation',
      //   component: () => import('@/views/service/cooperation/update'),
      //   meta: {title: '修改合作信息'},
      //   hidden: true
      // },
      // {
      //   path: 'reportMember',
      //   name: 'reportMember',
      //   component: () => import('@/views/service/reportMember/index'),
      //   meta: {title: '举报信息', icon: 'ums-menu'}
      // },
      // {
      //   path: 'addReportMember',
      //   name: 'addReportMember',
      //   component: () => import('@/views/service/reportMember/add'),
      //   meta: {title: '添加举报信息'},
      //   hidden: true
      // },
      // {
      //   path: 'updateReportMember',
      //   name: 'updateReportMember',
      //   component: () => import('@/views/service/reportMember/update'),
      //   meta: {title: '修改举报信息'},
      //   hidden: true
      // },
    ]
  },

  {
    path:'/integration',
    component: Layout,
    redirect: '/integration/task',
    name: 'integration',
    meta: {title: '积分管理', icon: 'example'},
    children: [
      {
        path: 'task',
        name: 'integrationTask',
        component: () => import('@/views/integration/task/index'),
        meta: {title: '积分任务', icon: 'ums-menu'}
      },
      {
        path: 'product',
        name: 'integrationProduct',
        component: () => import('@/views/integration/product/index'),
          meta: {title: '积分商城', icon: 'product-list'}
      },
      {
        path: 'order',
        name: 'integrationOrder',
        component: () => import('@/views/integration/order/index'),
        meta: {title: '兑换订单', icon: 'order'}
      },
      {
        path: 'sign',
        name: 'integrationSign',
        component: () => import('@/views/integration/sign/index'),
        meta: {title: '签到配置', icon: 'form'}
      },
      {
        path: 'level',
        name: 'integrationLevel',
        component: () => import('@/views/integration/level/index'),
        meta: {title: '积分等级', icon: 'skill'}
      },
      {
        path: 'memberIntegrationLog',
        name: 'memberIntegrationLog',
        component: () => import('@/views/log/memberIntegrationLog/index'),
        meta: {title: '会员积分日志查询', icon: 'ums-resource'}
      },
      {
        path: 'addMemberIntegrationLog',
        name: 'addMemberIntegrationLog',
        component: () => import('@/views/log/memberIntegrationLog/add'),
        meta: {title: '添加会员积分日志'},
        hidden: true
      },
      {
        path: 'updateMemberIntegrationLog',
        name: 'updateMemberIntegrationLog',
        component: () => import('@/views/log/memberIntegrationLog/update'),
        meta: {title: '修改会员积分日志'},
        hidden: true
      },
    ]
  },
  // {
  //   path: '/offlineDelivery',
  //   component: Layout,
  //   redirect: '/offlineDelivery/application',
  //   name: 'offlineDelivery',
  //   meta: {title: '线下发货管理', icon: 'order'},
  //   children: [
  //     {
  //       path: 'application',
  //       name: 'offlineDeliveryApplication',
  //       component: () => import('@/views/offlineDelivery/application/index'),
  //       meta: {title: '提货申请', icon: 'product-list'}
  //     },
  //     {
  //       path: 'application/detail',
  //       name: 'offlineDeliveryDetail',
  //       component: () => import('@/views/offlineDelivery/application/detail'),
  //       meta: {title: '申请详情'},
  //       hidden: true
  //     },
  //     {
  //       path: 'account',
  //       name: 'deliveryAccount',
  //       component: () => import('@/views/offlineDelivery/account/index'),
  //       meta: {title: '发货账号', icon: 'ums-admin'}
  //     }
  //   ]
  // },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js